import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Card } from '@/components/ui/Card';

interface DocumentoLacuna {
  categoria: string;
  nome: string;
  descricao: string | null;
}

interface DocumentosLacunasProps {
  lacunas: DocumentoLacuna[];
}

const CATEGORIA_LABELS: Record<string, string> = {
  produto: 'Produto',
  certificacao: 'Certificação',
  registro: 'Registro',
  licenca: 'Licença',
  atestado: 'Atestado',
  juridico: 'Jurídico',
  tecnico: 'Técnico',
  comercial: 'Comercial',
  estrategico: 'Estratégico',
};

function formatCategoria(categoria: string): string {
  return CATEGORIA_LABELS[categoria] || categoria;
}

export function DocumentosLacunas({ lacunas }: DocumentosLacunasProps) {
  if (lacunas.length === 0) {
    return (
      <Card className="p-4 mt-4 border-ds-success/30 bg-ds-success/5">
        <div className="flex items-start gap-3">
          <CheckCircle2 className="h-5 w-5 text-ds-success shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-ds-text-primary">
              Documentação completa para habilitação
            </p>
            <p className="text-xs text-ds-text-secondary mt-1">
              Pelo menos um documento de cada categoria comum está cadastrado.
            </p>
          </div>
        </div>
      </Card>
    );
  }

  const porCategoria = lacunas.reduce<Record<string, DocumentoLacuna[]>>((acc, lacuna) => {
    if (!acc[lacuna.categoria]) {
      acc[lacuna.categoria] = [];
    }
    acc[lacuna.categoria].push(lacuna);
    return acc;
  }, {});

  return (
    <Card className="p-4 mt-4 border-ds-warning/30 bg-ds-warning/5">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-ds-warning shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-ds-text-primary">
            Documentos recomendados que ainda não foram cadastrados
          </p>
          <p className="text-xs text-ds-text-secondary mt-1 mb-3">
            Esses documentos são frequentemente exigidos em editais. Cadastrá-los aumenta a chance de habilitação.
          </p>

          <div className="space-y-3">
            {Object.entries(porCategoria).map(([categoria, itens]) => (
              <div key={categoria}>
                <p className="text-xs font-medium text-ds-text-secondary uppercase tracking-wider mb-1">
                  {formatCategoria(categoria)}
                </p>
                <ul className="space-y-1">
                  {itens.map((item) => (
                    <li key={item.nome} className="text-sm text-ds-text-primary">
                      • {item.nome}
                      {item.descricao && (
                        <span className="text-ds-text-secondary ml-1">— {item.descricao}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
